var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillRule: "evenodd",
    d: "M2 3a2 2 0 012-2h7.586A2 2 0 0113 1.586L17.414 6A2 2 0 0118 7.414V17a2 2 0 01-2 2H4a2 2 0 01-2-2V3zm9.586 0H4v7.612l2.36-2.325.67-.658.7.626 2.201 1.97 1.933-1.932.672-.672.706.637L16 10.749V7.414L11.586 3zM16 13.444l-3.393-3.065-1.183 1.183L16 15.658v-2.214zM4 17v-3.581l3.095-3.048L14.501 17H4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentImage);
export default __webpack_public_path__ + "static/media/document-image.c88d97792835020861a748b01ee30e4b.svg";
export { ForwardRef as ReactComponent };